import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const VendorProLayout = lazy(() =>
  import('../components/vendor-pro/VendorProLayout').then((m) => ({ default: m.VendorProLayout }))
)
const VendProHubPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.HubPage }))
)
const VendProCockpitPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.CockpitPage }))
)
const VendProScorePage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ScorePage }))
)
const VendProMaturitePage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.MaturitePage }))
)
const VendProTprmPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.TprmFrameworkPage }))
)
const VendProDueDiligencePage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.DueDiligencePage }))
)
const VendProConcentrationPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ConcentrationPage }))
)
const VendProSubprocessorsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.SubprocessorsPage }))
)
const VendProContractsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ContractsPage }))
)
const VendProContractDetailPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ContractDetailPage }))
)
const VendProSlaPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.SlaMonitoringPage }))
)
const VendProRenewalsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.RenewalsPage }))
)
const VendProCostsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.CostsPage }))
)
const VendProScorecardsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ScorecardsPage }))
)
const VendProPerformancePage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.PerformancePage }))
)
const VendProCataloguePage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.CataloguePage }))
)
const VendProVendorDetailPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendorDetailPage }))
)
const VendProBenchmarksPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.BenchmarksPage }))
)
const VendProRgpdPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.RgpdPage }))
)
const VendProClausesPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ClausesPage }))
)
const VendProVendorAuditPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendorAuditPage }))
)
const VendProCertificationsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.CertificationsPage }))
)
const VendProReportExecPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendProReportExecPage }))
)
const VendProIntegrationPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendProIntegrationPage }))
)
const VendProAuditTrailPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendProAuditTrailPage }))
)
const VendProSettingsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendProSettingsPage }))
)
const VendProOutilsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendProOutilsPage }))
)
const VendProVendorIntelligencePage = lazy(() =>
  import('../pages/vendor-pro/VendorIntelligencePage').then((m) => ({ default: m.VendorIntelligencePage }))
)
const VendProExternalScoresPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ExternalScoresPage }))
)
const VendProThirdPartyConcentrationPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ThirdPartyConcentrationPage }))
)
const VendProThirdPartyMonitoringPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ThirdPartyMonitoringPage }))
)
const VendProThirdPartyRiskPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.ThirdPartyRiskPage }))
)
const VendProTprmQuestionnairePage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.TprmQuestionnairePage }))
)
const VendProVendorOnboardingPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendorOnboardingPage }))
)
const VendProVendorRiskExchangePage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendorRiskExchangePage }))
)
const VendProVendorRatingsPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendorRatingsPage }))
)
const VendProNthPartyGraphPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.NthPartyGraphPage }))
)
const VendProVendorSbomPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendorSbomPage }))
)
const VendProVendorContinuousMonitoringPage = lazy(() =>
  import('../pages/vendor-pro').then((m) => ({ default: m.VendorContinuousMonitoringPage }))
)
// TPRM #21 — nth-party graph + continuous security ratings (governance /vendor-pro/*)
const VendProNthPartyTprmPage = lazy(() =>
  import('../pages/vendor-pro/NthPartyTprmPage').then((m) => ({ default: m.NthPartyTprmPage }))
)

export const vendorProRoutes: RouteObject[] = [
  {
    path: '/vendor-pro',
    element: <VendorProLayout />,
    children: [
      { index: true, element: <VendProHubPage /> },

      { path: 'hub', element: <VendProHubPage /> },
      { path: 'cockpit', element: <VendProCockpitPage /> },
      { path: 'score', element: <VendProScorePage /> },
      { path: 'maturity', element: <VendProMaturitePage /> },
      { path: 'tprm', element: <VendProTprmPage /> },
      { path: 'due-diligence', element: <VendProDueDiligencePage /> },
      { path: 'concentration', element: <VendProConcentrationPage /> },
      { path: 'subprocessors', element: <VendProSubprocessorsPage /> },
      { path: 'contracts', element: <VendProContractsPage /> },
      { path: 'contracts/:id', element: <VendProContractDetailPage /> },
      { path: 'sla', element: <VendProSlaPage /> },
      { path: 'renewals', element: <VendProRenewalsPage /> },
      { path: 'costs', element: <VendProCostsPage /> },
      { path: 'scorecards', element: <VendProScorecardsPage /> },
      { path: 'performance', element: <VendProPerformancePage /> },
      { path: 'catalogue', element: <VendProCataloguePage /> },
      { path: 'vendors/:id', element: <VendProVendorDetailPage /> },
      { path: 'benchmarks', element: <VendProBenchmarksPage /> },
      { path: 'rgpd', element: <VendProRgpdPage /> },
      { path: 'clauses', element: <VendProClausesPage /> },
      { path: 'vendor-audit', element: <VendProVendorAuditPage /> },
      { path: 'certifications', element: <VendProCertificationsPage /> },
      { path: 'report-exec', element: <VendProReportExecPage /> },
      { path: 'integrations', element: <VendProIntegrationPage /> },
      { path: 'audit-trail', element: <VendProAuditTrailPage /> },
      { path: 'settings', element: <VendProSettingsPage /> },
      { path: 'outils', element: <VendProOutilsPage /> },
      { path: 'vendor-intelligence', element: <VendProVendorIntelligencePage /> },
      { path: 'external-scores', element: <VendProExternalScoresPage /> },
      { path: 'third-party-concentration', element: <VendProThirdPartyConcentrationPage /> },
      { path: 'third-party-monitoring', element: <VendProThirdPartyMonitoringPage /> },
      { path: 'third-party-risk', element: <VendProThirdPartyRiskPage /> },
      { path: 'tprm-questionnaire', element: <VendProTprmQuestionnairePage /> },
      { path: 'vendor-onboarding', element: <VendProVendorOnboardingPage /> },
      { path: 'risk-exchange', element: <VendProVendorRiskExchangePage /> },

      // S8 — Continuous Vendor & Nth-Party Monitoring
      { path: 'ratings', element: <VendProVendorRatingsPage /> },
      { path: 'nth-party-graph', element: <VendProNthPartyGraphPage /> },
      // TPRM #21 — continuous nth-party / ratings cockpit
      { path: 'nth-party', element: <VendProNthPartyTprmPage /> },
      { path: 'sbom', element: <VendProVendorSbomPage /> },
      { path: 'continuous-monitoring', element: <VendProVendorContinuousMonitoringPage /> },
    ],
  },
]
